import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from '../services/Common/configuration.service';
import CustomStore from 'devextreme/data/custom_store';
import * as AspNetData from "devextreme-aspnet-data-nojquery";


@Injectable()
export class AccountEndpoint extends EndpointFactory {

  private readonly _usersUrl: string = "/api/idp/Account/users";
  private readonly _manageUsersUrl: string = "/api/idp/Account/manageUsers";
  private readonly _healthManageUserPropertiesUrl: string = "/api/idp/Account/healthManageUserProperties";
  private readonly _lifeManageUserPropertiesUrl: string = "/api/idp/Account/lifeManageUserProperties";

  private readonly _usersListUrl: string = "/api/idp/Account/userslist";
  private readonly _userByUserNameUrl: string = "/api/idp/Account/users/username";
  private readonly _currentUserUrl: string = "/api/idp/Account/users/me";
  private readonly _currentUserPreferencesUrl: string = "/api/idp/Account/users/me/preferences";
  private readonly _unblockUserUrl: string = "/api/idp/Account/users/unblock";
  private readonly _rolesUrl: string = "/api/idp/Account/roles";
  private readonly _roleByRoleNameUrl: string = "/api/idp/Account/roles/name";
  private readonly _permissionsUrl: string = "/api/idp/Account/permissions";
  private readonly _updatePasswordUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/updatepassword`;
  private readonly _upsertuserUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/upsertuser`;
  private readonly _updateUserPropertiesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/updateUserProperties`;
  private readonly _updateUserRolesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/updateUserRoles`;
  private readonly _updateUserTenantServiceUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/updateTenantService`;



  private readonly _upsertuserpropertiesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/upsertuserproperties`;
  private readonly _checkUserConsentUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/checkuserconsent`;
  private readonly _amendUserConsentUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/amenduserconsent`;
  private readonly _nextApproverURL: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/shared/getnextapprover`;
  private readonly _usersByTenantURL: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/health/shared/getusersbytenant`;
  private readonly _sendWelcomeEmailURL: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/sendwelcomemail`;
  private readonly _importUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/importusers`;
  private readonly _switchUserTenantUrl: string = "/api/idp/shared/switchusertenant";
  private readonly _getUserTenantMapUrl: string = "/api/idp/Account/getusertenantmap";
  private readonly _resetBrokerPasswordUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/resetbrokerpassword`;
  private readonly _getReviewerListURL: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/health/shared/getreviewerlist`;
  private readonly _checkIndQuoteAccessURL: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/shared/checkindaccess`;
  private readonly _uploadTempBrokerUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/uploadtempbrokerusers`;
  private readonly _tempBrokerUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/tempbrokerusers`;
  // New endpoints for temp broker user CRUD
  private readonly _insertTempBrokerUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/inserttempbrokerusers`;
  private readonly _getPendingBrokerUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/getpendingbrokerusers`;
  private readonly _deleteTempBrokerUsersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/deletetempbrokerusers`;

  get usersUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._usersUrl; }
  get manageUsersUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._manageUsersUrl; }
  get healthManageUserPropertiesUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._healthManageUserPropertiesUrl; }
  get lifeManageUserPropertiesUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._lifeManageUserPropertiesUrl; }
  get usersListUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._usersListUrl; }
  get userByUserNameUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._userByUserNameUrl; }
  get currentUserUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._currentUserUrl; }
  get currentUserPreferencesUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._currentUserPreferencesUrl; }
  get unblockUserUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._unblockUserUrl; }
  get rolesUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._rolesUrl; }
  get roleByRoleNameUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._roleByRoleNameUrl; }
  get permissionsUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._permissionsUrl; }
  get checkUserConsentUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._checkUserConsentUrl; }
  get getUserTenantMapUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._getUserTenantMapUrl; }
  get switchUserTenantUrl() { return this.configurations.baseUrl + this.configurations.smartSuffix + this._switchUserTenantUrl; }
  private readonly _createLogoutContextURL: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Account/createLogoutContext`;

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

    super(http, configurations, injector);

    this.getAuthHeader_devextreme = this.getAuthHeader_devextreme.bind(this);
  }


  getManageUserEndpoint<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.manageUsersUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getManageUserEndpoint(userId));
      }));
  }

  getHealthManageUserProperties<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.healthManageUserPropertiesUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHealthManageUserProperties(userId));
      }));
  }
  getLifeManageUserProperties<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.lifeManageUserPropertiesUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getLifeManageUserProperties(userId));
      }));
  }
  getUserEndpoint<T>(userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserEndpoint(userId));
      }));
  }



  getUserByUserNameEndpoint<T>(userName: string): Observable<T> {
    let endpointUrl = `${this.userByUserNameUrl}/${userName}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserByUserNameEndpoint(userName));
      }));
  }


  getUsersEndpoint<T>(page?: number, pageSize?: number, tenantId?: number): Observable<T> {
    let endpointUrl = page && pageSize && tenantId ? `${this.usersUrl}/${page}/${pageSize}/${tenantId}` : this.usersUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUsersEndpoint(page, pageSize, tenantId));
      }));
  }

  getAllUsersListEndpoint(): CustomStore {
    return AspNetData.createStore({
      key: 'userId',
      loadParams: {},
      loadUrl: this.usersListUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }

    });
  }

  getUsersByTenantEndpoint<T>(tenantId: number, entityId: number, serviceId: number): Observable<T> {
    let endpointUrl = `${this._nextApproverURL}/${tenantId}/${entityId}/${serviceId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUsersByTenantEndpoint(tenantId, entityId, serviceId));
      }));
  }

  getUsersByTenantIdEndpoint<T>(tenantId: number): Observable<T> {
    let endpointUrl = `${this._usersByTenantURL}/${tenantId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUsersByTenantIdEndpoint(tenantId));
      }));
  }

  getReviewerList<T>(): Observable<T> {
    let endpointUrl = `${this._getReviewerListURL}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getReviewerList());
      }));
  }

  getNewUserEndpoint<T>(userObject: any): Observable<T> {

    return this.http.post<T>(this.usersUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewUserEndpoint(userObject));
      }));
  }

  sendWelcomeEmailEndPoint<T>(userId: string): Observable<T> {
    return this.http.put<T>(this._sendWelcomeEmailURL, JSON.stringify(userId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.sendWelcomeEmailEndPoint(userId));
      }));
  }

  getUpdateUserEndpoint<T>(userObject: any, userId?: string): Observable<T> {
    let endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;

    return this.http.put<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateUserEndpoint(userObject, userId));
      }));
  }

  // getAllUsersEndpoint<T>(): Observable<T> {
  //   let endpointUrl =  this.usersUrl;

  //   return this.http.get<T>(endpointUrl,   this.getRequestHeaders()).pipe<T>(
  //     catchError(error => {
  //       return this.handleError(error, () => this.getAllUsersEndpoint());
  //     }));
  // }
  getAllUsersEndpoint(searchTxt: string): CustomStore {
    return AspNetData.createStore({
      loadParams: { searchTxt: searchTxt },
      key: "id",
      loadUrl: this.usersUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }

  getPatchUpdateUserEndpoint<T>(patch: {}, userId?: string): Observable<T>
  getPatchUpdateUserEndpoint<T>(value: any, op: string, path: string, from?: any, userId?: string): Observable<T>
  getPatchUpdateUserEndpoint<T>(valueOrPatch: any, opOrUserId?: string, path?: string, from?: any, userId?: string): Observable<T> {
    let endpointUrl: string;
    let patchDocument: {};

    if (path) {
      endpointUrl = userId ? `${this.usersUrl}/${userId}` : this.currentUserUrl;
      patchDocument = from ?
        [{ "value": valueOrPatch, "path": path, "op": opOrUserId, "from": from }] :
        [{ "value": valueOrPatch, "path": path, "op": opOrUserId }];
    }
    else {
      endpointUrl = opOrUserId ? `${this.usersUrl}/${opOrUserId}` : this.currentUserUrl;
      patchDocument = valueOrPatch;
    }

    return this.http.patch<T>(endpointUrl, JSON.stringify(patchDocument), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPatchUpdateUserEndpoint(valueOrPatch, opOrUserId, path, from, userId));
      }));
  }


  getUserPreferencesEndpoint<T>(): Observable<T> {

    return this.http.get<T>(this.currentUserPreferencesUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserPreferencesEndpoint());
      }));
  }

  getUpdateUserPreferencesEndpoint<T>(configuration: string): Observable<T> {
    return this.http.put<T>(this.currentUserPreferencesUrl, JSON.stringify(configuration), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateUserPreferencesEndpoint(configuration));
      }));
  }

  getUnblockUserEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.unblockUserUrl}/${userId}`;

    return this.http.put<T>(endpointUrl, null, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUnblockUserEndpoint(userId));
      }));
  }

  getDeleteUserEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.usersUrl}/${userId}`;

    return this.http.delete<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteUserEndpoint(userId));
      }));
  }
  updateUserProperties<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._updateUserPropertiesUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateUserProperties(obj));
      }));
  }
  updateUserRoles<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._updateUserRolesUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateUserRoles(obj));
      }));
  }
  updateTenantService<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._updateUserTenantServiceUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateTenantService(obj));
      }));
  }



  upsertuserEndpoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._upsertuserUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.upsertuserEndpoint(obj));
      }));
  }
  upsertuserpropertiesEndpoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._upsertuserpropertiesUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.upsertuserpropertiesEndpoint(obj));
      }));
  }
  updatePasswordEndpoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._updatePasswordUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updatePasswordEndpoint(obj));
      }));
  }




  getRoleEndpoint<T>(roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleEndpoint(roleId));
      }));
  }


  getRoleByRoleNameEndpoint<T>(roleName: string): Observable<T> {
    let endpointUrl = `${this.roleByRoleNameUrl}/${roleName}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRoleByRoleNameEndpoint(roleName));
      }));
  }



  getRolesEndpoint<T>(page?: number, pageSize?: number): Observable<T> {
    let endpointUrl = page && pageSize ? `${this.rolesUrl}/${page}/${pageSize}` : this.rolesUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRolesEndpoint(page, pageSize));
      }));
  }

  getRolesByTenantEndpoint<T>(tenantId: number): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${tenantId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getRolesByTenantEndpoint(tenantId));
      }));
  }

  getUserTenantMapEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.getUserTenantMapUrl}/${userId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserTenantMapEndpoint(userId));
      }));
  }
  checkIndQuoteAccess<T>(): Observable<T> {

    return this.http.get<T>(this._checkIndQuoteAccessURL, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.checkIndQuoteAccess());
      }));
  }
  createLogoutContext<T>(): Observable<T> {

    return this.http.get<T>(this._createLogoutContextURL, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createLogoutContext());
      }));
  }


  getNewRoleEndpoint<T>(roleObject: any): Observable<T> {

    return this.http.post<T>(this.rolesUrl, JSON.stringify(roleObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNewRoleEndpoint(roleObject));
      }));
  }

  getUpdateRoleEndpoint<T>(roleObject: any, roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(roleObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateRoleEndpoint(roleObject, roleId));
      }));
  }

  getDeleteRoleEndpoint<T>(roleId: string): Observable<T> {
    let endpointUrl = `${this.rolesUrl}/${roleId}`;

    return this.http.delete<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDeleteRoleEndpoint(roleId));
      }));
  }


  getPermissionsEndpoint<T>(): Observable<T> {

    return this.http.get<T>(this.permissionsUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPermissionsEndpoint());
      }));
  }

  checkUserConsentEndpoint<T>(): Observable<boolean> {
    let endpointUrl = `${this._checkUserConsentUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.checkUserConsentEndpoint());
      }));

  }

  amendUserConsent<T>(): Observable<any> {
    return this.http.post<T>(this._amendUserConsentUrl, null, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.amendUserConsent());
      }));
  }

  importUsers<T>(): Observable<T> {
    let endpointUrl = `${this._importUsersUrl}`;

    return this.http.post<T>(endpointUrl, null, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.importUsers());
      }));
  }

  switchUserTenant<T>(tenantId: number, userId: string): Observable<any> {
    let endpointUrl = `${this.switchUserTenantUrl}/${tenantId}/${userId}`;
    return this.http.post<T>(endpointUrl, this.getRequestHeaders()).pipe<T>( //JSON.stringify(tenantId),
      catchError(error => {
        return this.handleError(error, () => this.switchUserTenant(tenantId, userId));
      }));
  }

  resetBrokerPassword<T>(): Observable<T> {
    let endpointUrl = `${this._resetBrokerPasswordUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.resetBrokerPassword());
      }));
  }

  uploadTempBrokerUsers<T>(file: File): Observable<T> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<T>(this._uploadTempBrokerUsersUrl, form, this.getDocRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.uploadTempBrokerUsers(file)))
    ); 
  }

  getTempBrokerUsersEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this._tempBrokerUsersUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.getTempBrokerUsersEndpoint()))
    );
  }

  updateTempBrokerUserEndpoint<T>(row: any): Observable<T> {
    return this.http.post<T>(this._tempBrokerUsersUrl, JSON.stringify(row), this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.updateTempBrokerUserEndpoint(row)))
    );
  }

  insertTempBrokerUsers<T>(payload: any): Observable<T> {
    return this.http.post<T>(this._insertTempBrokerUsersUrl, JSON.stringify(payload), this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.insertTempBrokerUsers(payload)))
    );
  }

  getPendingBrokerUsers<T>(): Observable<T> {
    return this.http.get<T>(this._getPendingBrokerUsersUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.getPendingBrokerUsers()))
    );
  }

  deleteTempBrokerUsers<T>(ids: number[]): Observable<T> {
    return this.http.delete<T>(this._deleteTempBrokerUsersUrl, { headers: this.getRequestHeaders().headers, body: ids }).pipe<T>(
      catchError(error => this.handleError(error, () => this.deleteTempBrokerUsers(ids)))
    );
  }
}
